import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const QuickFilterButton = styled(Button)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '120%',
  padding: '6px 12px',
  borderRadius: '46px',
  textTransform: 'none',
  color: theme.customColors.black70,
  backgroundColor: 'transparent',
  border: `1px solid ${theme.customColors.black10}`,
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.customColors.black10,
  },
  // Для активной (contained) кнопки
  '&.MuiButton-contained': {
    backgroundColor: theme.customColors.primary10,
    color: theme.customColors.black,
    borderColor: theme.customColors.primary10,
  },
  // Для outlined (неактивной)
  '&.MuiButton-outlined': {
    backgroundColor: 'transparent',
    color: theme.customColors.black70,
    borderColor: theme.customColors.black10,
  },
}));
